import React from "react";
import PropTypes from "prop-types";
import { Button, IconButton, Typography } from "@mui/material";
import "./PrimaryButton.css";

function PrimaryButton({
  classBtn,
  text = "",
  click,
  startIcon = null,
  endIcon = null,
  btnType = "",
  disabled,
  style,
  fontSize,
  type
}) {
  return (
    <>
      {btnType !== "icon" ? (
        <Button
          className={classBtn}
          onClick={click}
          startIcon={startIcon}
          endIcon={endIcon}
          disabled={disabled}
          style={style}   
          type={type||'button'}       
        >
          <Typography fontSize={fontSize}>
            {text}

          </Typography>
        </Button>
      ) : (
        <IconButton
          style={style}
          fullwidth="true"
          className={classBtn}
          onClick={click}
        >
          {startIcon}
        </IconButton>
      )}
    </>
  );
}

PrimaryButton.propTypes = {
  variant: PropTypes.string,
  classBtn: PropTypes.string,
  text: PropTypes.string,
  click: PropTypes.func,
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
};

export default PrimaryButton;
